import Raven from 'raven-js';

import gqlClientFactory from '@services/gql/index';
import { EventCountryQuery } from '@services/gql/event';
import { supportedSlugs } from '../../../data/locale';
import getUrl from './getUrl';

const DEFAULT_ERROR = {
  status: 404,
  message: 'Event not found',
};

const DEFAULT_SUCCESS = {
  status: 200,
};

const getEventGql = (eventId) => {
  const eventIdInt = parseInt(eventId, 10);
  const gql = gqlClientFactory();

  return gql.query({
    query: EventCountryQuery,
    variables: {
      eventId: eventIdInt,
    },
  });
};

/*
 Performs 301 redirect from old URL or /e/xxx shortcut to normalized URL

 http://localhost:3000/e/test-booking-with-tom-172593 -->
 http://localhost:3000/gb/e/test-booking-with-tom-172593

 http://localhost:3000/e/172593 -->
 http://localhost:3000/gb/e/test-booking-with-tom-172593

Important:
 - logic for events with correct URL is still handled on Container level
 - logic for missing events / null data is still handled on Container level
 */

const getHandleRedirect = () => {
  return async (nextState, replace, callback) => {
    const { params } = nextState;
    const { eventSlug, eventId, localeSlug } = params;

    // this is correct url, do nothing
    if (eventSlug && eventId && localeSlug) {
      return callback();
    }

    // prevent recursion
    if (nextState.location.state && nextState.location.state.status) {
      return callback();
    }

    let res;
    try {
      res = await getEventGql(eventId);
    } catch (exc) {
      Raven.captureException(exc);
      return callback();
    }

    const event = res && res.data.event;
    if (!event) {
      // event data is null let the container handle not found
      callback();
      return;
    }
    const country = event && event.place.address.countryShort;
    const slug = event && event.slug;

    // Perform country sub folder 301 redirect
    if (country) {
      let newUrl = getUrl.eventPage(country, slug, eventId);

      const path = nextState.location.pathname.split('/').filter((e) => !!e);

      // todo @marian improve naming
      const slugIndex = path.indexOf(`${eventSlug}-${eventId}`);
      const slugEndIndex = slugIndex < 0 ? path.indexOf(eventId) : slugIndex;
      const nestedPath = path.splice(slugEndIndex + 1, path.length);

      newUrl = [newUrl, ...nestedPath].join('/');

      // url is correct do nothing, @todo marian write test for this
      if (newUrl === nextState.location.pathname) {
        return callback();
      }

      const nextLocation = {
        pathname: newUrl,
        search: nextState.location.search,
        hash: nextState.location.hash,
      };

      replace(nextLocation);

      /*
       we know that URL is completely incorrect, safely to return 404
       check state to avoid recursion
       */
    } else if (!nextState.location.state) {
      const nextLocation = {
        ...nextState.location,
        state: DEFAULT_ERROR,
      };

      replace(nextLocation);
    }

    callback();
  };
};

function validateCountryRoute(eventCountry, router) {
  if (!router.params.eventSlug) {
    return DEFAULT_SUCCESS.status; // Ignore short links
  }
  if (
    !router.params.localeSlug &&
    !supportedSlugs.includes(eventCountry.toLowerCase())
  ) {
    return DEFAULT_SUCCESS.status; // Route for Rest of World
  }
  if (
    supportedSlugs.includes(eventCountry.toLowerCase()) &&
    router.params.localeSlug &&
    router.params.localeSlug.toLowerCase() === eventCountry.toLowerCase()
  ) {
    return DEFAULT_SUCCESS.status; // Supported Country sub folders
  }
  return DEFAULT_ERROR.status;
}

export {
  getHandleRedirect,
  validateCountryRoute,
  DEFAULT_ERROR,
  DEFAULT_SUCCESS,
};
